<template>
  <p>Loading screen...</p>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      accessGroup: "",
    };
  },

  methods: {
    handleLoginEvent(data) {
      // Record a "Logged In" event once per genuine authentication, for every
      // user regardless of landing route. Callback is mounted only during the
      // auth callback, so this does NOT fire on silent token renewals.
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let EventHistory = "Logged In";

      axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
        this.response = response.data;
        let UserIPAddress = this.response.substring(
          this.response.search("ip=") + 3,
          this.response.search("ts=") - 1
        );
        let sendUrl =
          "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userhistory";

        let sendData = {
          UserURN: data.profile.sub,
          UserIPAddress: UserIPAddress,
          HistoryDate: HistoryDate,
          HistoryTime: HistoryTime,
          HistoryNote: EventHistory,
          ProfilePortal: data.profileportal,
        };
        let sendHeaders = this.$apikeyPost;
        axios
          .post(sendUrl, sendData, sendHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => "error: " + err);
      });

      if (data.accessGroup === "Installer") {
        this.$router.push(data.state.target || "/Commission");
      } else if (data.profileportal == "TST") {
        this.$router.push(data.state.target || "/Testers");
      } else if (data.profileportal == "RSK") {
        this.$router.push(data.state.target || "/RiskAssessmentQuestionnaire");
      } else if (data.profileportal == "CLI") {
        this.$router.push(data.state.target || "/Overview");
      } else if (data.profileportal == "MAI") {
        this.$router.push(data.state.target || "/Maintenance");
      } else {
        this.$router.push(data.state.target || "/Overview");
      }
    },
  },
  created() {
    this.$auth.handleAuthentication();
  },
};
</script>
